// extracted by mini-css-extract-plugin
export var compactFilters = "_gf-4";
export var detailImage = "_gf-1";
export var dropdownContainer = "_gf-2";
export var imageContainer = "_gf-0";
export var selectedCard = "_gf-3";